import { PanelRange, Bloodwork, PanelField } from '.';

const WBC_ABSOLUTE_DIFFERENTIALS = [
    'neutrophilsAbsolute', 
    'lymphocytesAbsolute', 
    'monocytesAbsolute', 
    'eosinophilsAbsolute', 
    'basophilsAbsolute'
];

const WBC_PERCENT_DIFFERENTIALS = [
    'neutrophilsPercent',
    'lymphocytesPercent',
    'monocytesPercent', 
    'eosinophilsPercent', 
    'basophilsPercent'
];

const WBC_DIFFERENTIALS = [
    'neutrophils', 
    'lymphocytes', 
    'monocytes', 
    'eosinophils', 
    'basophils',
    ...WBC_ABSOLUTE_DIFFERENTIALS
];

export class BloodworkRange extends PanelRange  {
    static bloodworkRangesFrom(bloodworkRanges: BloodworkRange[]): BloodworkRange[] {
        const wbcDiffPercentRanges: BloodworkRange[] = [];
        
        const newBloodworkRanges = bloodworkRanges.map((bloodworkRange: BloodworkRange) => {
            const newBloodworkRange = new BloodworkRange(bloodworkRange).init();
            if (newBloodworkRange.isWBCPercentDifferential()) {
                wbcDiffPercentRanges.push(newBloodworkRange);
            }
            return newBloodworkRange;
        });

        const wbcDiffPercentageRanges = wbcDiffPercentRanges.map((percentRange) => {
            const range = new BloodworkRange(percentRange);
            range.attribute = range.attribute.replace(Bloodwork.PERCENT, '');
            range.optimalMin = range.optimalMin != null ? range.optimalMin : 0;
            return range.init()
        });
        return [...newBloodworkRanges, ...wbcDiffPercentageRanges];
    }

    constructor(bloodworkRange?: BloodworkRange) {
        super();
        // This handles copying the simple properties
        if (!bloodworkRange) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(bloodworkRange).forEach(key => {
            this[key] = bloodworkRange[key];
        });
    }

    init?(): BloodworkRange {
        const panelField = PanelField.findField(PanelField.ALL_FIELDS, this.attribute);
        const precision: number = panelField ? panelField.precision : 2;
        super.init(precision != null ? precision : 2);
        return this;
    }

    isRedBloodCells?(): boolean {
        return this.attribute === Bloodwork.RED_BLOOD_CELLS;
    }

    isWBCDifferential?(): boolean {
        return WBC_DIFFERENTIALS.indexOf(this.attribute) > -1;
    }

    isWBCAbsoluteDifferential?(): boolean {
        return WBC_ABSOLUTE_DIFFERENTIALS.indexOf(this.attribute) > -1;
    }

    isWBCPercentDifferential?(): boolean {
        return WBC_PERCENT_DIFFERENTIALS.indexOf(this.attribute) > -1;
    }
}